<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Small Employer Relief (SER)</h1>
    <p>Small Employer Relief (SER) is a scheme that allows small employers to claim additional relief on their statutory recovery claims.</p>
    <p>To assess whether your company is eligible for Small Employer Relief view <a href="https://www.gov.uk/recover-statutory-payments" target="_blank">gov.uk</a></p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="custom-check">
             <input type="checkbox" v-model="formData.hasSmallEmployersRelief">My company is eligible for Small Employers Relief
            <span class="checkmark"></span>
        </label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

const error = ref(null)
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {


  return true;
}


import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "Company",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }



  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>